<template>
  <p>
    For inquiries relating to the scientific content of the conference or sponsorship possibilities,
    please contact the VIZBI chairs:
  </p>
  <p><Email to="vizbi-contact" /></p>
  <p>
    For inquiries about practical matters (registration, transport, hotels etc.), please contact the
    EMBL Course and Conference Office:
  </p>
  <p>Adela Valceanu</p>
  <p><strong>Tel:</strong> +49 6221 387 8625</p>
  <p>
    <strong>Address:</strong> European Molecular Biology Laboratory, Meyerhofstra&szlig;e 1, 69117
    Heidelberg, Germany.
  </p>
</template>

<script setup>
import Email from "@/components/Email.vue";
</script>
